import type { HealthFeatureConfig } from '../../../types/insurances/HealthFeatureConfig';

export const health: HealthFeatureConfig = {
    overview: {
        details: {
            showVariant: false,
            showContractNumber: false,
            showContractHolder: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
            showCard: false,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
